document.addEventListener('DOMContentLoaded', () => {
  // Scroll reveal (progressive enhancement only — elements are visible by default)
  const els = document.querySelectorAll('.fade-in');
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    els.forEach(el => el.classList.add('pre-anim'));
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: .1 });
    els.forEach(el => io.observe(el));
  }

  // Size selector -> set variant id on hidden input
  document.querySelectorAll('.size-row').forEach(row => {
    row.querySelectorAll('.size-btn').forEach(btn => {
      if (btn.disabled) return;
      btn.addEventListener('click', () => {
        row.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const input = document.getElementById('product-variant-id') || row.closest('form')?.querySelector('input[name="id"]');
        if (input && btn.dataset.variant) input.value = btn.dataset.variant;
      });
    });
  });

  // Quick-add on collection/product cards
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variant;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(() => {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        });
        btn.textContent = '✓';
        setTimeout(() => btn.textContent = 'Legg i kurv', 1500);
      });
    });
  });

  // Cart qty +/- via /cart/change
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      if (!btn.dataset.href) return;
      e.preventDefault();
      window.location.href = btn.dataset.href;
    });
  });
});

// Color selector — filters size buttons + swaps featured image
document.querySelectorAll('.color-row').forEach(row => {
  row.querySelectorAll('.color-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      row.querySelectorAll('.color-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const color = btn.dataset.color;
      const form = row.closest('form');
      const sizeRow = form?.querySelector('.size-row');
      if (!sizeRow) return;

      let firstVisible = null;
      sizeRow.querySelectorAll('.size-btn').forEach(sb => {
        const match = sb.dataset.color === color;
        sb.style.display = match ? '' : 'none';
        if (match && !sb.disabled && !firstVisible) firstVisible = sb;
      });

      // auto-select first available size for this color
      sizeRow.querySelectorAll('.size-btn').forEach(sb => sb.classList.remove('active'));
      if (firstVisible) {
        firstVisible.classList.add('active');
        const input = document.getElementById('product-variant-id');
        if (input) input.value = firstVisible.dataset.variant;
        if (firstVisible.dataset.image) {
          const img = document.getElementById('product-featured-image');
          if (img) img.src = firstVisible.dataset.image;
        }
      }
    });
  });
});

// Mobil: "Les mer" toggle for lang produktbeskrivelse
(function(){
  const desc = document.querySelector('.product-info .desc');
  if (!desc) return;
  if (window.innerWidth > 768) return;
  if (desc.scrollHeight <= desc.offsetHeight + 10) return; // ikke nødvendig
  const toggle = document.createElement('button');
  toggle.className = 'desc-toggle';
  toggle.textContent = 'Les mer ↓';
  desc.after(toggle);
  toggle.addEventListener('click', () => {
    desc.classList.toggle('expanded');
    toggle.textContent = desc.classList.contains('expanded') ? 'Vis mindre ↑' : 'Les mer ↓';
  });
})();
